import { N as NcActionButton } from "./chunks/NcActionButton-CECxOkhK.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-D_ldp8Lw.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import { N as NcActionCheckbox } from "./chunks/NcActionCheckbox-D9aQuEYw.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-CB9jcc0_.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import { N as NcActionRadio } from "./chunks/NcActionRadio-BmVR-lhZ.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-C-CwY6XQ.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import { N as NcActionTextEditable } from "./chunks/NcActionTextEditable-CNEW3Fav.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-BvgsOP0K.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-DgekTp_z.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-D7mH8K7B.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-B6YKr1n2.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import { N as NcAppNavigationNew } from "./chunks/NcAppNavigationNew-t3Rkrwjh.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-C96AER1b.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-CuqE2exX.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-Ba8OcJxl.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-PRGGDKCy.mjs";
import { N as NcAppSettingsSection } from "./chunks/NcAppSettingsSection-Cq1VIzMR.mjs";
import { N as NcAppSettingsShortcutsSection } from "./chunks/NcAppSettingsShortcutsSection-BGMDhIXI.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-1Q4AznUI.mjs";
import { N as NcAppSidebarHeader } from "./chunks/NcAppSidebarHeader-CBE4tNYb.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAssistantButton } from "./chunks/NcAssistantButton-BPXX2mz6.mjs";
import NcAssistantContent from "./Components/NcAssistantContent.mjs";
import { N as NcAssistantIcon } from "./chunks/NcAssistantIcon-CKWZRzXg.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-4h0wo9uv.mjs";
import { u } from "./chunks/NcAvatar-4h0wo9uv.mjs";
import { N as NcBlurHash } from "./chunks/NcBlurHash-DZmsBU0q.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-CcKJsew_.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-bDlnNcz1.mjs";
import { N as NcButton } from "./chunks/NcButton-Dz2O6cSU.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-CX3HXCEk.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-CejmntlL.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-BERjJHgc.mjs";
import { N as NcContent } from "./chunks/NcContent-yW5m-Mj5.mjs";
import { N as NcCounterBubble } from "./chunks/NcCounterBubble-oxV8oMlX.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-Bk6i__T-.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem--NyYqf1-.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-enXYuwj8.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-8ipQ69_t.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-CSC8PAz-.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-DlizXqla.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import { N as NcFormBox } from "./chunks/NcFormBox-DL435pbV.mjs";
import { N as NcFormBoxButton } from "./chunks/NcFormBoxButton-DR_OMvmB.mjs";
import { N as NcFormBoxCopyButton } from "./chunks/NcFormBoxCopyButton-BQt4cqDo.mjs";
import { N as NcFormBoxSwitch } from "./chunks/NcFormBoxSwitch-BqbGsapa.mjs";
import { N as NcFormGroup } from "./chunks/NcFormGroup-BfsPo9aC.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import { N as NcHeaderButton } from "./chunks/NcHeaderButton-Dvo1_Bwc.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-Cuh8ay0F.mjs";
import { N as NcHighlight } from "./chunks/index-CxTT94_h.mjs";
import { N as NcHotkey } from "./chunks/NcHotkey-DcpG5Pla.mjs";
import { N as NcHotkeyList } from "./chunks/NcHotkeyList-CV_FJXF8.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-Bui9PhAS.mjs";
import { N as NcInputField } from "./chunks/NcInputField-CZRuRX_c.mjs";
import { N as NcListItem } from "./chunks/NcListItem-DP0kl2g5.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-D41xabRp.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-D2xXHnvI.mjs";
import { N as NcPopover } from "./chunks/NcPopover-gxcAqoEb.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-D7zYeXBH.mjs";
import { N as NcRadioGroup } from "./chunks/NcRadioGroup-D0rC63G8.mjs";
import { N as NcRadioGroupButton } from "./chunks/NcRadioGroupButton-3Pu4Iqdf.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-BbjG2Qvg.mjs";
import { N as NcMentionBubble } from "./chunks/index-TmAR7I2T.mjs";
import { r } from "./chunks/index-TmAR7I2T.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-S7ASR6NI.mjs";
import "@nextcloud/auth";
import "@nextcloud/axios";
import "@nextcloud/router";
import "@nextcloud/sharing/public";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a, g, b, c, s, d } from "./chunks/referencePickerModal-eu8fU-gn.mjs";
import { N, h, c as c2, i, e, r as r2, f, a as a2 } from "./chunks/customPickerElements-DLFtgReB.mjs";
import "unist-builder";
import "unist-util-visit";
import "./chunks/logger-D3RVzcfQ.mjs";
import { N as NcRichText } from "./chunks/NcRichText-C7k_8zuH.mjs";
import { N as NcSelect } from "./chunks/NcSelect-CkB50N9T.mjs";
import { N as NcTextField } from "./chunks/NcTextField-CijJWC3h.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-U7AIamCl.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-DrDrZUA6.mjs";
import { N as NcSelectUsers } from "./chunks/NcSelectUsers-HmMuAP19.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-wFKkjw2t.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-ZV3KIsxm.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-CXGxufce.mjs";
import { N as NcTextArea } from "./chunks/NcTextArea-CIgfjLRv.mjs";
import { N as NcThemeProvider } from "./chunks/NcThemeProvider-25ResoIv.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-DOSucwRx.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-CSGX6IdN.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-Dfd_lPCI.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { useFormatDateTime, useFormatRelativeTime, useFormatTime } from "./Composables/useFormatDateTime.mjs";
import { useHotKey } from "./Composables/useHotKey.mjs";
import { useIsDarkTheme, useIsDarkThemeElement } from "./Composables/useIsDarkTheme.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { getEnabledContactsMenuActions, registerContactsMenuAction } from "./Functions/contactsMenu.mjs";
import { spawnDialog } from "./Functions/dialog.mjs";
import { E, a as a3, e as e2, g as g2, s as s2 } from "./chunks/emoji-BY_D0V5K.mjs";
import { checkIfDarkTheme, isDarkTheme } from "./Functions/isDarkTheme.mjs";
import { preloadImage } from "./Functions/preloadImage.mjs";
import { usernameToColor } from "./Functions/usernameToColor.mjs";
import directive from "./Directives/Focus.mjs";
import directive$1 from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSettingsSectionShortcuts: NcAppSettingsShortcutsSection,
  NcAppSettingsShortcutsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcFormBox,
  NcFormBoxButton,
  NcFormBoxCopyButton,
  NcFormBoxSwitch,
  NcFormGroup,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcHotkey,
  NcHotkeyList,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSettingsShortcutsSection as NcAppSettingsSectionShortcuts,
  NcAppSettingsShortcutsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcFormBox,
  NcFormBoxButton,
  NcFormBoxCopyButton,
  NcFormBoxSwitch,
  NcFormGroup,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcHotkey,
  NcHotkeyList,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a as anyLinkProviderId,
  checkIfDarkTheme,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e2 as emojiSearch,
  g2 as getCurrentSkinTone,
  getEnabledContactsMenuActions,
  g as getLinkWithPicker,
  b as getProvider,
  c as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  c2 as isCustomPickerElementRegistered,
  isDarkTheme,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  preloadImage,
  registerContactsMenuAction,
  e as registerCustomPickerElement,
  r2 as registerWidget,
  f as renderCustomPickerElement,
  a2 as renderWidget,
  r as richEditor,
  s as searchProvider,
  s2 as setCurrentSkinTone,
  d as sortProviders,
  spawnDialog,
  useFormatDateTime,
  useFormatRelativeTime,
  useFormatTime,
  useHotKey,
  useIsDarkTheme,
  useIsDarkThemeElement,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  usernameToColor
};
//# sourceMappingURL=index.mjs.map
